const isDeviceCloudPrinter = () => (
  JSON.parse(
    localStorage.getItem("cpd") || "false"
  )
)

export default isDeviceCloudPrinter